export enum LightboxMode {
  lightboxStyles = 'lightboxStyles',
  documentPreview = 'documentPreview',
}

export default interface ILightboxComponent{
  isVisible: boolean;
  closePreview: () => void;
  small?: boolean;
  style?: LightboxMode;
  header?: string;
}

export type TLightboxComponent = {
  mode: LightboxMode;
};
